import { render, staticRenderFns } from "./draggable-popup.vue?vue&type=template&id=6bf5f53f&scoped=true&"
import script from "./draggable-popup.vue?vue&type=script&lang=js&"
export * from "./draggable-popup.vue?vue&type=script&lang=js&"
import style0 from "./draggable-popup.vue?vue&type=style&index=0&id=6bf5f53f&scoped=true&lang=css&"
import style1 from "./draggable-popup.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf5f53f",
  null
  
)

export default component.exports